// src/slices/profile/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAllProfiles, getProfileById, getProfileBySlug } from "./thunk";

const initialState = { list: [], singleProfile: null, loading: false, error: null };

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile(state) {
      state.singleProfile = null;
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getAllProfiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.data || action.payload;
      })
      .addCase(getAllProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY ID =================
      .addCase(getProfileById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfileById.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProfile = action.payload?.data || action.payload;
      })
      .addCase(getProfileById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY SLUG =================
      .addCase(getProfileBySlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfileBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProfile = action.payload?.data || action.payload;
      })
      .addCase(getProfileBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
